import Cookies from 'js-cookie';

export function getJwtToken() {
	return Cookies.get('jwt_token');
}

export function getRefreshToken() {
	return Cookies.get('refresh_token');
}

export function getKeepLogin() {
	return Cookies.get('keep_login');
}

export function setTokens(
	token,
	refreshToken,
	accessTokenExpired,
	refreshTokenExpired,
	keepLogIn,
) {
	let result = false;

	if (keepLogIn) {
		// Convert milliseconds to exact expiration dates
		const accessTokenExpiresDate = new Date(accessTokenExpired);
		const refreshTokenExpiresDate = new Date(refreshTokenExpired);
		Cookies.set('jwt_token', token, { expires: accessTokenExpiresDate });
		Cookies.set('refresh_token', refreshToken, {
			expires: refreshTokenExpiresDate,
		});
		Cookies.set('keep_login', keepLogIn, {
			expires: refreshTokenExpiresDate,
		});
		result = true;
	} else {
		Cookies.set('jwt_token', token);
		Cookies.set('refresh_token', refreshToken);
		Cookies.set('keep_login', keepLogIn);
		result = true;
	}
	if (process.env.VUE_APP_BUILD_MODE === 'DEV' ) {
		console.log('토큰 세팅 결과', result);
	}
	return result;
}
export function removeTokens() {
	Cookies.remove('jwt_token');
	Cookies.remove('refresh_token');
	Cookies.remove('keep_login');
}

export function isAuthenticated() {
	//리프레쉬 토큰이 만료되면 로그인정보가 만료되는 것으로 간주한다.
	const token = Cookies.get('refresh_token');
	return (
		token !== undefined &&
		token !== null &&
		token !== '' &&
		token !== 'undefined'
	);
}
